

export const GirasPresentation = ({ lang }) => {
  const tours = ['fourDays', 'fiveDays', 'sixDays', 'sevenDays', 'eightDays',];
  return (
    <div className="giras-presentation">
        {
            tours.map( (tour, i) => {
                return (<img src={`../assets/giras/${tour}${lang.charAt(0).toUpperCase() + lang.slice(1)}.jpg`} className={`giras-presentation-img`} alt={tour} key={`${i}-Giras-Tour-${tour}`} />);
            })
        }
    </div>
  )
}
